///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.consumer_rfp = abcsetup.consumer_rfp || {};
abcsetup.consumer_rfp.list_rfi = abcsetup.consumer_rfp.list_rfi || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.consumer_rfp.list_rfi = {
    formRenderInstance: null,

    init() {
        abcsetup.setTitle('List Consumer RFP Event');

        this.initListeners();
        abcsetup.consumer_rfp.list_rfi.dataTable();

        // abcsetup.consumer_rfp.common.init();
        //abcsetup.consumer_rfp.common.setupEventBindings();
    },

    initListeners: () => {
    },

    dataTable: () => {

        axios.get('/api/consumer_rfp/' + $('#rfp_id').val() + '/datatable').then(response =>
        {
            if (response.data.table_data)
            {
                $('#rfi_data .dataTables_wrapper').remove();
                $('#rfi_data_table').append(response.data.table_data);

                // Init datatables
                abcsetup.datatables.init($('#rfi_data_table').find('#' + response.data.table_id), {
                    bInfo: true,
                    scroll_horizontal: true,
                    "lengthMenu": [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, 'All']],
                    "iDisplayLength": 25,
                    "order": [],
                    "responsive": false,
                    "scrollParentOffset": 220,
                    "language": {
                        "emptyTable": "No outstanding tasks"
                    },
                    "columnDefs": [
                        {
                            "targets": 0,
                            "orderable": false
                        }
                    ],
                });
            }

            // Update total count of items needing attention
            var count = $(response.data.table_data).find('tbody tr').length;

        }).catch(error => {
           console.log(error);
        });
    }
}
